export default __webpack_public_path__ + "static/media/icon-publication.b13e359b.svg";